import Swal from 'sweetalert2'

$(document).ready(function() {
    const account = {
        isLoadingInfo: false,
        isLoadingPasswordInfo: false,
        isLoadingEmail: false,
        isLoadingUserCI: false,
        isLoadingUserDL: false,
        isLoadingUploadCI: false,
        isLoadingUploadDL: false,
        init() {
            $(document).on('click', '#user-page-save-details', this, this.updatePersonalInfo);
            $(document).on('click', '#update-password', this, this.updatePassword);
            $(document).on('click', '#emails-preferences-save', this, this.updateEmailPreferences);
            $(document).on('click', '.cancel-reservation', this, this.cancelReservation);
            $(document).on('click', '#update-user-ci', this, this.updateUserCI);
            $(document).on('click', '#update-user-dl', this, this.updateUserDL);
            $(document).on('change', '#user-ci-file', this, this.uploadCiFile);
            $(document).on('change', '#user-dl-file', this, this.uploadDlFile);

            $(document).on('click', '#upload-user-ci', this, function() {
				$('#user-ci-file').trigger('click');
			});
            $(document).on('click', '#upload-user-dl', this, function() {
				$('#user-dl-file').trigger('click');
			});
        },
		uploadDlFile(event) {
			const _this = event.data;

			if (_this.isLoadingUploadDL) { return false; }

			let file = $('#user-dl-file')[0].files;
			if (file.lenght < 1) { return; }
			if (file[0].type == 'image/jpeg' && file[0].type == 'application/pdf' && file[0].type == 'image/png') {
				Swal.fire({
					icon: 'error',
					title: 'Error!',
					html: $('#upload-user-dl').data('error')
				});
				return;
			}

			//Loading...
            _this.isLoadingUploadDL = true;
			let element = $('#upload-user-dl');
			element.find('i').show();

			const formData = new FormData();
			formData.append('file', file[0]);
			formData.append('_token', $('#_token_user_dl').val());

			$.ajax({
	            type: "POST",
	            url: `${baseURL}/account/upload-dl-file`,
				data: formData,
                //async: false,
                //cache: false,
                contentType: false,
                processData: false,
	            success: function(response) {
					_this.isLoadingUploadDL = false;
					element.find('i').hide();

					if (response.status == 1) {

						$('#upload-user-dl-container').html(`<a href="${response.file_url}" target="_blank" class="btn btn-lg btn-outline-primary py-1 fw-bold border-2 w-100">${response.file_label} <i class="fas fa-eye ms-3"></i></a>`);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						return false;
					}

					Swal.fire({
						icon: 'error',
						title: 'Error!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoadingUploadDL = false;
					element.find('i').hide();
                },
	        });
		},
		uploadCiFile(event) {
			const _this = event.data;

			if (_this.isLoadingUploadCI) { return false; }

			let file = $('#user-ci-file')[0].files;
			if (file.lenght < 1) { return; }
			if (file[0].type == 'image/jpeg' && file[0].type == 'application/pdf' && file[0].type == 'image/png') {
				Swal.fire({
					icon: 'error',
					title: 'Error!',
					html: $('#upload-user-ci').data('error')
				});
				return;
			}

			//Loading...
            _this.isLoadingUploadCI = true;
			let element = $('#upload-user-ci');
			element.find('i').show();

			const formData = new FormData();
			formData.append('file', file[0]);
			formData.append('_token', $('#_token_user_ci').val());

			$.ajax({
	            type: "POST",
	            url: `${baseURL}/account/upload-ci-file`,
				data: formData,
                //async: false,
                //cache: false,
                contentType: false,
                processData: false,
	            success: function(response) {
					_this.isLoadingUploadCI = false;
					element.find('i').hide();

					if (response.status == 1) {

						$('#upload-user-ci-container').html(`<a href="${response.file_url}" target="_blank" class="btn btn-lg btn-outline-primary py-1 fw-bold border-2 w-100">${response.file_label} <i class="fas fa-eye ms-3"></i></a>`);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						return false;
					}

					Swal.fire({
						icon: 'error',
						title: 'Error!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoadingUploadCI = false;
					element.find('i').hide();
                },
	        });
		},
        updateEmailPreferences(event) {
			const _this = event.data;

            if (_this.isLoadingEmail) {
                return false;
            }

			//Loading...
            _this.isLoadingEmail = true;

			var values = '_token=' + $('#_token_email').val();
            values += '&newsletter=' + ($('#newsletter').is(":checked")?1:0);
            values += '&promotions=' + ($('#promotions').is(":checked")?1:0);

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-email-preferences`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingEmail = true;
                },
                complete: function() {
                    _this.isLoadingEmail = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingEmail = false;

                    if (response.status == 1) {
                        $('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
						return false;
                    }

					$('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                },
                error(error) {
                    _this.isLoadingEmail = false;
                    $('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                },
            });

		},
        updatePersonalInfo(event) {
            const _this = event.data;

            if (_this.isLoadingInfo) {
                return false;
            }

			$('#profile-notifications').html();
            $('#profile-form').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingInfo = true;
			let element = this;
			$(element).find('i').show();

            var values = '_token=' + $('#_token_profile').val();
            values += '&email=' + $('#email').val();
            values += '&phone=' + $('#phone').val();
            values += '&first_name=' + $('#first_name').val();
            values += '&last_name=' + $('#last_name').val();
            values += '&date_of_birth=' + $('#date_of_birth').val();
            values += '&country_id=' + $('#country_id option:selected').val();
            // values += '&gender=' + $('input[name=gender]:checked').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-info `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingInfo = true;
                },
                complete: function() {
                    _this.isLoadingInfo = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingInfo = false;
					$(element).find('i').hide();

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        // $('#profile-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: 'Encountered an error!',
                            content: `<p>${response.message}</p>`,
                            type: 'red',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'fas fa-exclamation-triangle',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
                        return false;
                    }

                    if (response.status == 1) {
                        // $('#profile-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: 'Success',
                            content: `<p>${response.message}</p>`,
                            type: 'green',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'far fa-thumbs-up',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
						return false;
                    }

					$.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
                error(error) {
                    _this.isLoadingInfo = false;
					$(element).find('i').hide();
					// $('#profile-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                    $.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
            });
        },
        updatePassword(event) {
            const _this = event.data;

            if (_this.isLoadingPasswordInfo) {
                return false;
            }

			$('#password-notifications').html();
            $('#password-form').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingPasswordInfo = true;
			let element = this;
			$(element).find('i').show();

            var values = '_token=' + $('#_token_password').val();
            values += '&old_password=' + $('#old_password').val();
            values += '&new_password=' + $('#new_password').val();
            values += '&new_password_confirmation=' + $('#new_password_confirmation').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-password `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingPasswordInfo = true;
                },
                complete: function() {
                    _this.isLoadingPasswordInfo = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingPasswordInfo = false;
					$(element).find('i').hide();

					$('#old_password').val('');
					$('#new_password').val('');
					$('#new_password_confirmation').val('');

                    if (response.status == 0) {
						var errorMessage = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
								errorMessage += '<br />'+response.errors[errorKey];
                            }
                        }

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: response.message,
                            content: `<p>${errorMessage}</p>`,
                            type: 'red',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'fas fa-exclamation-triangle',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
                        return false;
                    }

                    if (response.status == 1) {

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: 'Success',
                            content: `<p>${response.message}</p>`,
                            type: 'green',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'far fa-thumbs-up',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
						return false;
                    }

					$.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
                error(error) {
                    _this.isLoadingPasswordInfo = false;
					$(element).find('i').hide();
                    // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                    $.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
            });
        },
        updateUserCI(event) {
            const _this = event.data;

            if (_this.isLoadingUserCI) {
                return false;
            }

            $('#form-user-ci').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingUserCI = true;
			let element = this;
			$(element).find('i').show();

            var values = '_token=' + $('#_token_user_ci').val();
            values += '&passport_series=' + $('#passport_series').val();
            values += '&passport_number=' + $('#passport_number').val();
            values += '&id_series=' + $('#id_series').val();
            values += '&id_number=' + $('#id_number').val();
            values += '&id_value=' + $('#id_value').val();
            values += '&issuer_id=' + $('#issuer_id').val();
            values += '&address=' + $('#address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-user-ci `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingUserCI = true;
                },
                complete: function() {
                    _this.isLoadingUserCI = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingUserCI = false;
					$(element).find('i').hide();

                    if (response.status == 0) {
						var errorMessage = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
								errorMessage += '<br />'+response.errors[errorKey];
                            }
                        }

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: response.message,
                            content: `<p>${errorMessage}</p>`,
                            type: 'red',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'fas fa-exclamation-triangle',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
                        return false;
                    }

                    if (response.status == 1) {

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: 'Success',
                            content: `<p>${response.message}</p>`,
                            type: 'green',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'far fa-thumbs-up',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
						return false;
                    }

					$.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
                error(error) {
                    _this.isLoadingUserCI = false;
					$(element).find('i').hide();
                    // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                    $.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
            });
        },
        updateUserDL(event) {
            const _this = event.data;

            if (_this.isLoadingUserDL) {
                return false;
            }

            $('#form-user-dl').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingUserDL = true;
			let element = this;
			$(element).find('i').show();

            var values = '_token=' + $('#_token_user_dl').val();
            values += '&driving_license_expiration_date=' + $('#driving_license_expiration_date').val();
            values += '&driving_license=' + $('#driving_license').val();
            values += '&driving_license_category=' + $('#driving_license_category').val();
            values += '&driving_license_issuer=' + $('#driving_license_issuer').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-driver-license `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingUserDL = true;
                },
                complete: function() {
                    _this.isLoadingUserDL = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingUserDL = false;
					$(element).find('i').hide();

                    if (response.status == 0) {
						var errorMessage = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
								errorMessage += '<br />'+response.errors[errorKey];
                            }
                        }

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: response.message,
                            content: `<p>${errorMessage}</p>`,
                            type: 'red',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'fas fa-exclamation-triangle',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
                        return false;
                    }

                    if (response.status == 1) {

                        // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                        $.confirm({
                            title: 'Success',
                            content: `<p>${response.message}</p>`,
                            type: 'green',
                            typeAnimated: true,
                            animationBounce: 1.5,
                            icon: 'far fa-thumbs-up',
                            theme: 'dark',
                            buttons: {
                                close: function () {
                                }
                            }
                        });
						return false;
                    }

					$.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
                error(error) {
                    _this.isLoadingUserDL = false;
					$(element).find('i').hide();
                    // $('#password-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                    $.confirm({
                        title: 'Encountered an error!',
                        content: `<p>Error: Something went wrong please contact an administrator!</p>`,
                        type: 'red',
                        typeAnimated: true,
                        animationBounce: 1.5,
                        icon: 'fas fa-exclamation-triangle',
                        theme: 'dark',
                        buttons: {
                            close: function () {
                            }
                        }
                    });
                },
            });
        },
		cancelReservation(event) {
			let id = $(this).data('id');
			let alertText = $(this).data('alert-text');
			let link = this;

			Swal.fire({
				title: $(this).data('alert-title'),
				text: alertText,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: $(this).data('btn-yes'),
				cancelButtonText: $(this).data('btn-no')
			}).then((result) => {

				if (!result.isConfirmed) {
					return false;
				}

				var values = '_token=' + $('#_token_reservation').val();
	            values += '&id=' + id;

	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/reservations/cancel`,
	                data: values,
	                beforeSend: function() {},
	                complete: function() {},
	                success: function(response, xhr) {

	                    if (response.status == 1) {
							$('.reservation-status').html(response.data);
							$(link).remove();
							Swal.fire(
								'Success',
								response.message,
								'success'
							);
							return false;
	                    }

						Swal.fire(
							'Error',
							response.message,
							'error'
						);
	                },
	                error(error) {
	                    alert('Error: Something went wrong please contact an administrator!');
	                },
	            });
			});
		},
    };

    if ( $('#account-profile').length ) {
        account.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/account.js